export var LLMAnswerType;
(function (LLMAnswerType) {
    LLMAnswerType["Response"] = "response";
})(LLMAnswerType || (LLMAnswerType = {}));
export var ProviderChatInteractionStatus;
(function (ProviderChatInteractionStatus) {
    ProviderChatInteractionStatus["Succeeded"] = "succeeded";
    ProviderChatInteractionStatus["Failed"] = "failed";
})(ProviderChatInteractionStatus || (ProviderChatInteractionStatus = {}));
//# sourceMappingURL=types.js.map